import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  toggleTourApi,
  getNotificationsApi,
  markAsReadApi,
  markAllAsReadApi,
} from '../../api/utilities';
import { AuthenticationService } from './auth.service';
import { NotificationsResponse } from '../../layout/shared/models/notification.model';

@Injectable({ providedIn: 'root' })
export class UtilitiesService {
  private notificationsUpdatedSubject = new Subject<void>();
  public notificationsUpdated$ =
    this.notificationsUpdatedSubject.asObservable();

  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) {}

  /**
   * Mostrar o ocultar el tour
   */
  toggleTour(): Observable<any> {
    return toggleTourApi(this.authenticationService.getToken(), this.http);
  }

  /**
   * Obtener notificaciones
   * @param queryParams parámetros para la petición a la API
   */
  getNotifications(queryParams: any = {}): Observable<NotificationsResponse> {
    return getNotificationsApi(
      this.http,
      this.authenticationService.getToken()!,
      queryParams
    ).pipe(
      map((response: NotificationsResponse) => {
        return response;
      })
    );
  }

  /**
   * Marcar como leída una notificación
   * @param id Notification ID
   */
  markAsRead(id: number): Observable<any> {
    return markAsReadApi(
      this.http,
      this.authenticationService.getToken()!,
      id
    ).pipe(
      map((response: any) => {
        this.notificationsUpdatedSubject.next();
        return response;
      })
    );
  }

  /**
   * Marcar todas las notificaciones como leídas
   */
  markAllAsRead(): Observable<any> {
    return markAllAsReadApi(
      this.http,
      this.authenticationService.getToken()!
    ).pipe(
      map((response: any) => {
        this.notificationsUpdatedSubject.next();
        return response;
      })
    );
  }
}
